import React, { Component, useState, useEffect,useRef } from "react";
import ContractorFormField from "../../Common/ContractorForm/ContractorFormField";
import {
  AsyncAutocompleteField,
  Switch,
  GridItem,
  GridWrapper,
  FilledButton,
  OutlinedButton,
  TextInput,
  TextInputField,
  CheckboxField,
  AutocompleteField,
  SelectField,
  TextArea,
  Input,
} from "@sainsburys-tech/luna-react";
import ContractorForm from "../../Common/ContractorForm";
import { Card } from "@sainsburys-tech/luna-card";
import { Accordion } from "@sainsburys-tech/luna-accordion";
import ConfirmationModal from "../../Common/ContractorForm/ConfirmationModal";
import FormAlerts from "../../Common/ContractorForm/FormAlerts";

import {
  LevelType,
  UserListType,
  UsersAndLevelList,
  AddComanyWeekendOnCall,
} from "../../../types/Entities/WeekendOnCallType";
import weekendOnCallApi from "../../../api/weekendOnCallApi";
// import ApiClient from 'src/api/ApiClient';
import { useApiClient } from "../../../context/AppContext";
import CSS from "csstype";

type AddWeekendProps = {
  userList: UsersAndLevelList | undefined;
  onData: any;
};

const AddWeekend = ({ userList, onData }: AddWeekendProps) => {
  const errorStyle: CSS.Properties = {
    textAlign: "left",
    marginLeft: "-10px",
    marginBottom: "10px",
  };
  const duplicateUserList = { ...userList };
  const apiClient = useApiClient();
  const pathName = window.location.pathname;
  const [currentDate, setCurrentDate] = useState("");
  const [modalState, setModalState] = useState<
    "savescm" | "noChange" | "discard" | false
  >(false);
  const [errorAlert, setErrorAlert] = useState<false | string>(false);
  const [successAlert, setSuccessAlert] = useState<false | string>(false);
  const [users, setUsers] = useState(
    userList?.ddlUserList ? [...userList?.ddlUserList] : []
  );
  const [startDateTime, setStartDateTime] = useState<string>(
    userList?.startDateAndTime ? userList?.startDateAndTime : ""
  );
  const [endDateTime, setEndDateTime] = useState<string>(
    userList?.endDateAndTime ? userList?.endDateAndTime : ""
  );
  const [defaultStartDate, setDefaultStartDateTime] = useState<string>("");
  const [defaultEndDate, setDefaultEndDateTime] = useState<string>("");
  const [service, setService] = useState<string>(
    userList?.service ? userList?.service : ""
  );
  const [showInvalidDate, setShowInvalidDate] = useState(false);
  const [disableButtons, setDisableButtons] = useState(false);
  const [disableStartDate, setDisableStartDate] = useState(false);
  const [hoveredRowId, setHoveredRowId] = useState<string | null>(null);//notes
  const [hoveredText, setHoveredText] = useState<string | boolean | null>(null);//notes
  const [showDialog, setShowDialog] = useState<boolean>(false);//notes
  const [showNotesDialog, setShowNotesDialog] = useState<boolean>(false);
  const [hoveredEmailId, setHoveredEmailId] = useState<string | null>(null);//email
  const [popUpBox, setPopUpBox] = useState<boolean>(false);//email
  const [hoveredemail, setHoveredEmail] = useState<string | boolean | null>(
    null
  );//email
  const isTouchDevice = "ontouchstart" in window || navigator.maxTouchPoints > 0;
  const popoverRef = useRef(null);


  const [weekendsRow, setWeekendsRows] = useState<UserListType[]>([
    {
      name: "",
      rowId: crypto.randomUUID().toString(),
      id: crypto.randomUUID().toString(),
      companyUserId: "",
      email: "",
      phone: "",
      notes: "",
      level: "",
      isNew: 1,
    },
  ]);

  const [levels, setLevel] = useState(
    userList?.ddlLevel
  ) as unknown as LevelType[];

  useEffect(() => {
    const now = new Date();
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, "0"); // Months are zero-based
    const day = String(now.getDate()).padStart(2, "0");
    const hours = String(now.getHours()).padStart(2, "0");
    const minutes = String(now.getMinutes()).padStart(2, "0");
    // const seconds = String(now.getSeconds()).padStart(2, '0');
    const todayDateTime = `${year}-${month}-${day} ${hours}:${minutes}`;
    const todayDateOnly = `${year}-${month}-${day}T00:00`;
    setCurrentDate(todayDateOnly);
    setDefaultStartDateTime(`${year}-${month}-${day}T00:00`);
    setDefaultEndDateTime(`${year}-${month}-${day}T23:59`);
    if (!startDateTime) {
      setStartDateTime(`${year}-${month}-${day}T00:00`);
      // const date = new Date(`${year}-${month}-${day}T23:59`);
      // date.setDate(date.getDate() + 2);
      // const newDate = date.toISOString();
      setEndDateTime(`${year}-${month}-${day}T23:59`);
      // setDefaultEndDateTime(newDate.split('.')[0])
      // setEndDateTime(`${year}-${month}-${day}T23:59`)
    }
    if (pathName === "/edit-weekend" && userList?.users) {
      const temp = userList?.users.map((x) => ({
        ...x,
        isNew: null,
        rowId: x.id,
      }));
      // setDuplicateUsers([...temp])
      const currentDateTime = new Date(todayDateTime).getTime();
      setDisableStartDate(
        currentDateTime > new Date(startDateTime).getTime()
      );
      setWeekendsRows(temp);
      setDisableButtons(
        currentDateTime > new Date(endDateTime).getTime()
      );
    }
  }, []);
  const handleMouseOver = (rowId: string, notes: string) => {
    setHoveredRowId(rowId);
    console.log("hii");

    if (notes) {
      setHoveredText(true);
      setShowDialog(true);
    } else {
      setHoveredText("No notes available.");
      setShowDialog(false);
    }
  };
//   const handleEmailToggle = (rowId: string, email: string) => {
//     if (isTouchDevice) {
//       // Toggle popover on touch devices
//       if (hoveredEmailId === rowId) {
//         setHoveredEmailId(null);
//         setPopUpBox(false);
//         setHoveredEmail(null);
//       } else {
//         setHoveredEmailId(rowId);
//         setPopUpBox(true);
//         setHoveredEmail(email||"");
//       }
//     }
//   };
const handleEmailToggle = (rowId: string, email: string) => {
    if (hoveredEmailId === rowId) {
      // Close the popover if the same email is clicked again
      setHoveredEmailId(null);
      setPopUpBox(false);
      setHoveredEmail(null);
    } else {
      // Ensure only one popover is open at a time
      setHoveredEmailId(rowId);
      setPopUpBox(true);
      setHoveredEmail(email ||"");
    }
  };
  

  // const handleMouseOut = () => {
  //   setHoveredRowId(null);
  //   setShowDialog(false);
  //   setHoveredText(null);
  // };
  const handleMouseOverEmail = (rowId: string, email: string) => {
    // Close any previously open popups
    setHoveredEmailId(rowId);
    setPopUpBox(true);
    setHoveredEmail(email || "");
  };
  
  const handleMouseOutEmail = () => {
    setHoveredEmailId(null);
    setPopUpBox(false);
    setHoveredEmail(null);
  };
  const handleMouseOverNotes = (rowId: string, notes: string) => {
    if (!isTouchDevice) {
      setHoveredRowId(rowId);
      setShowNotesDialog(true);
      setHoveredText(notes);
    }
  };
  
  const handleMouseOutNotes = () => {
    setHoveredRowId(null);
    setShowNotesDialog(false);
    setHoveredText(null);
  };
  const handleClickNotes = (rowId: string, notes: string) => {
    if (isTouchDevice) {
      if (hoveredRowId === rowId) {
        setHoveredRowId(null);
        setShowNotesDialog(false);
        setHoveredText(null);
      } else {
        setHoveredRowId(rowId);
        setShowNotesDialog(true);
        setHoveredText(notes);
      }
    }
  };
  
  const clearNotesPopUp = () => {
    setShowNotesDialog(false);
  };
  
  const scrollToTop = () =>
    document.querySelector("div.ln-o-container.content")?.scrollTo(0, 0);

  const addRowToGrid = () => {
    let newguid = crypto.randomUUID();
    setWeekendsRows([
      ...weekendsRow,
      {
        id: "",
        rowId: newguid.toString(),
        companyUserId: "",
        name: "",
        email: "",
        phone: "",
        isNew: 1,
        notes: "",
        level: "",
      },
    ]);
  };

  const removeRowFromGrid = (
    event: React.MouseEvent<HTMLButtonElement>,
    rowIndex: string
  ) => {
    let fmlist = [...weekendsRow];
    if (fmlist.length === 1) {
      return;
    }
    const element = event.target as HTMLButtonElement;
    var foundIndex = fmlist.findIndex((x) => x.rowId == rowIndex);
    // if (fmlist[foundIndex]['isNew'] === 1) {
    //     const wONCall = fmlist.filter(x => x.rowId !== rowIndex)
    //     setWeekendsRows(wONCall);
    //     return
    // }

    if (fmlist[foundIndex].name !== "") {
      onData(
        `You have removed ${fmlist[foundIndex].name}. To save the changes, please click on the Save button.`,
        "ErrorAlert"
      );
      scrollToTop();
    }
    if (fmlist[foundIndex]["isNew"] === 1) {
      // onData(`You have removed ${fmlist[foundIndex].name}. To save the changes, please click on the Save button.`, 'ErrorAlert')
      fmlist.splice(foundIndex, 1);
    } else {
      // onData(`You have removed ${fmlist[foundIndex].name}. To save the changes, please click on the Save button.`, 'ErrorAlert')
      fmlist[foundIndex]["isNew"] = 0;
    }
    setWeekendsRows(fmlist);
    // setSuccessAlert(false)
  };

  const textInputOnChange = (event: any, rowIndex: string) => {
    const element = event.target;
    const validValue = event.target.value;
    const scmlist = [...weekendsRow];
    let itemindex = scmlist.findIndex((i) => i.rowId === rowIndex);

    scmlist[itemindex]["notes"] = element.value;
    setWeekendsRows(scmlist);
  };

  const handleDateOnSave = () => {
    if (showInvalidDate) {
      onData(
        "Please ensure all fields are filled out correctly.",
        "ErrorAlert"
      );
      scrollToTop();
      return;
    }
    if (!startDateTime || !endDateTime) {
      scrollToTop();
      onData("All fields marked with * are mandatory.", "ErrorAlert");
      return;
    }

    const strtDateTime = new Date(startDateTime).getTime();
    const edDateTime = new Date(endDateTime).getTime();
    const minDateTime = new Date(currentDate).getTime();
    
    if (pathName === "/add-weekend" && strtDateTime < minDateTime) {
      scrollToTop();
      onData(`Start Date cannot be earlier than today.`, "ErrorAlert");
      return;
    }
    
    if (edDateTime < minDateTime) {
      scrollToTop();
      onData(`End Date cannot be earlier than today.`, "ErrorAlert");
      return;
    }
    
    if (edDateTime <= strtDateTime) {
      scrollToTop();
      onData(`End Date must be greater than Start Date.`, "ErrorAlert");
      return;
    }

    const numberOfRows = [...weekendsRow].filter(
      (x: any) => x.companyUserId !== "" && x.name !== ""
    ).length;
    if (numberOfRows < 1) {
      scrollToTop();
      onData("Please select atleast one user.", "ErrorAlert");
      return;
    }
    
    // Check if any visible row has empty name
    const hasEmptyName = [...weekendsRow].filter((x: any) => x.isNew !== 0).some((x: any) => !x.name || x.name === "");
    if (hasEmptyName) {
      scrollToTop();
      onData("Name field is mandatory. Please select a name for all rows or remove the empty rows.", "ErrorAlert");
      return;
    }
    
    setModalState("savescm");
  };

  const handleSaveForm = () => {
    setModalState(false);
    const cmpnyONCallUD = weekendsRow
      .filter((x: any) => x.companyUserId !== "")
      .map((x: any) =>
        x.isNew === 1
          ? {
              CompanyUserId: x.companyUserId,
              level: x.level,
              Notes: x.notes,
              // isNew: x.isNew
            }
          : {
              Id: x.id,
              CompanyUserId: x.companyUserId,
              level: x.level,
              Notes: x.notes,
              isNew: x.isNew,
            }
      );

    const payload = {
      CompanyId: users[0].companyUserId,
      Detail: service.trim(),
      StartDate:
        startDateTime.length < 19 ? startDateTime + ":00" : startDateTime,
      EndDate: endDateTime.length < 19 ? endDateTime + ":00" : endDateTime,
      CompanyOnCallUserDetails: cmpnyONCallUD,
    };
    pathName === "/add-weekend"
      ? postAddWeekend(payload).then(scrollToTop)
      : updateWeekend(payload).then(scrollToTop);
  };

  const updateWeekend = (payload: AddComanyWeekendOnCall) => {
    return weekendOnCallApi
      .updateComanyWeekendOnCall(apiClient, payload)
      .then(async (res) => {
        if (res.ok) {
          // onData('submit')
          const payloadDate =
            payload.StartDate.replace("T", " ") +
            " / " +
            payload.EndDate.replace("T", " ");
          console.log(payloadDate);
          onData(payloadDate, "SuccessAlert-Update");
        } else {
          const errorData = await res.json();
          if (errorData["BadRequest"]) {
            onData(errorData["BadRequest"], "ErrorAlert");
          } else {
            onData("Something went wrong!", "ErrorAlert");
          }
        }
      })
      .catch((err) => onData("Something went wrong!", "ErrorAlert"));
  };
  const useClickOutside = (ref:any, callback:any) => {//callback: A function to execute when the user clicks outside the referenced element.
    useEffect(() => {
      const handleClickOutside = (event:any) => {
        if (ref.current && !ref.current.contains(event.target)) {//Returns true if the clicked element is inside the referenced element.
                                                        //Returns false if the clicked element is outside, triggering the callback().
          callback();   
        }
      };
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, [ref, callback]);
  };
  
useClickOutside(popoverRef, () => {//Calls useClickOutside to automatically close the popover when clicking outside.
  setHoveredEmailId(null);
  setPopUpBox(false);
});//useRef is used to keep a reference to the popover so that we can detect clicks outside of it.

  const postAddWeekend = (payload: AddComanyWeekendOnCall) => {
    return weekendOnCallApi
      .addComanyWeekendOnCall(apiClient, payload)
      .then(async (res) => {
        if (res.ok) {
          onData(
            "Weekend On-Call Details added successfully.",
            "SuccessAlert-Add"
          );
          let newguid = crypto.randomUUID();
          setWeekendsRows([
            {
              id: newguid.toString(),
              rowId: newguid.toString(),
              companyUserId: newguid.toString(),
              name: "",
              email: "",
              phone: "",
              isNew: 1,
              notes: "",
              level: "",
            },
          ]);
          setService("");
          setStartDateTime("");
          setEndDateTime("");
        } else {
          const errorData = await res.json();
          if (errorData["BadRequest"]) {
            onData(errorData["BadRequest"], "ErrorAlert");
          } else {
            onData("Something went wrong!", "ErrorAlert");
          }
        }
      })
      .catch((err) => onData("Something went wrong!", "ErrorAlert"));
  };

  const handleDiscardForm = () => {
    setModalState(false);
    // if (duplicateUsers) {
    if (pathName === "/add-weekend") {
      let newguid = crypto.randomUUID();
      setWeekendsRows([
        {
          id: newguid.toString(),
          rowId: newguid.toString(),
          companyUserId: newguid.toString(),
          name: "",
          email: "",
          phone: "",
          isNew: 1,
          notes: "",
          level: "",
        },
      ]);
      setService("");
      setStartDateTime(defaultStartDate);
      setEndDateTime(defaultEndDate);
      return;
    }
    onData("discard");
    // }-
  };

  const handleChange = (
    option: { target: { value: string } },
    id: string,
    rowId: string
  ) => {
    const findIndex = [...weekendsRow].findIndex((x) => x.rowId == rowId);
    let WONCall = [...weekendsRow];
    WONCall[findIndex]["name"] = option.target.value;
    setWeekendsRows(WONCall);
  };

  const handleSelect = (option: any, id: string, rowId: string) => {
    const findIndex = [...weekendsRow].findIndex((x) => x.rowId == rowId);
    let WONCall = [...weekendsRow];
    if (!option) {
      WONCall = WONCall.map((x) =>
        x.rowId === rowId
          ? {
              ...x,
              name: "",
              email: "",
              phone: "",
              companyUserId: "",
            }
          : x
      );
    } else {
      WONCall = WONCall.map((x) =>
        x.rowId === rowId
          ? {
              ...x,
              companyUserId: option.id,
              name: option.name,
              email: option.email,
              phone: option.phone,
            }
          : x
      );
    }
    setWeekendsRows(WONCall);
  };

  const truncateText = (text: string, malgength: number) => {
    if (text.length > malgength) {
      return text.substring(0, malgength) + "...";
    }
    return text;
  };

  const onChanageLevels = (value: string, rowIndex: string) => {
    const wONCall = weekendsRow.map((x) =>
      x.rowId === rowIndex ? { ...x, level: value } : x
    );
    setWeekendsRows(wONCall);
  };

  const handleServiceChange = (value: string) => {
    setService(value);
  };

  return (
    <>
      <ConfirmationModal
        showModal={modalState}
        onClose={() => setModalState(false)}
        onSave={handleSaveForm}
        onDiscard={handleDiscardForm}
      />

      {/* <FormAlerts
                showError={errorAlert}
                showSuccess={successAlert}
                onClose={clearAlerts}
            /> */}
      <div style={{ background: "white", padding: "0" }}>
        {pathName === "/add-weekend" && (
          <div>
            <ContractorFormField label="Service">
              <TextInputField
                name="text-input-field-2"
                onChange={(e: any) => {
                  handleServiceChange(e.target.value);
                }}
                // onChange={(e: any) => setService(e.target.value)}
                value={service}
              />
            </ContractorFormField>
          </div>
        )}
        <div style={{ marginTop: "20px", marginLeft: "15px" }}>
          {/* <div style={{ display: 'grid', gridTemplateColumns: '50% 50% 50%' }}> */}
          {/* {pathName === '/add-weekend' && ( */}
          <div>
            <ContractorFormField label="">
              <div className="dateAndTime">
                <div>
                  <label htmlFor="startDateTime">
                    <b> StartDate & Time</b> <b style={{ color: "red" }}>*</b>
                  </label>
                  <Input
                    type="datetime-local"
                    name="startDateTime"
                    id="startDateTime"
                    style={{ padding: "5% 8%", width: "90%" }}
                    value={
                      startDateTime.length == 19
                        ? startDateTime.slice(0, -3)
                        : startDateTime
                    }
                    min={currentDate}
                    disabled={disableButtons || disableStartDate}
                    // max={(startDateTime > currentDate) ? endDateTime : startDateTime}
                    // onKeyDown={(e: any) => e.preventDefault()}
                    onChange={(e: any) => {
                      const inputValue = e.target.value;
                      const selectedDateTime = new Date(inputValue);
                      const minDateTime = new Date(currentDate).getTime();
                      const endDateTimeValue = new Date(endDateTime).getTime();

                      // Validate date format and check for invalid dates (including hours > 23)
                      const dateTimePattern = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}$/;
                      if (!dateTimePattern.test(inputValue)) {
                        if (!disableStartDate && !disableButtons) {
                          setStartDateTime(inputValue);
                          setShowInvalidDate(true);
                        }
                        return;
                      }

                      const [datePart, timePart] = inputValue.split('T');
                      const [year, month, day] = datePart.split('-').map(Number);
                      const [hours, minutes] = timePart.split(':').map(Number);

                      // Check for invalid hour (must be 0-23 in 24-hour format)
                      if (hours > 23 || minutes > 59) {
                        if (!disableStartDate && !disableButtons) {
                          setStartDateTime(inputValue);
                          setShowInvalidDate(true);
                        }
                        return;
                      }

                      // Check if the date itself is valid (e.g., no Nov 31, Feb 30)
                      if (isNaN(selectedDateTime.getTime()) || 
                          selectedDateTime.getFullYear() !== year ||
                          selectedDateTime.getMonth() !== month - 1 ||
                          selectedDateTime.getDate() !== day ||
                          selectedDateTime.getHours() !== hours ||
                          selectedDateTime.getMinutes() !== minutes) {
                        if (!disableStartDate && !disableButtons) {
                          setStartDateTime(inputValue);
                          setShowInvalidDate(true);
                        }
                        return;
                      }

                      const selectedDateTimeMs = selectedDateTime.getTime();

                      // Check if manually entered date is less than today's date (00:00)
                      if (selectedDateTimeMs < minDateTime) {
                        if (!disableStartDate && !disableButtons) {
                          setStartDateTime(inputValue);
                          setShowInvalidDate(true);
                        }
                      } else if (endDateTime && selectedDateTimeMs >= endDateTimeValue) {
                        // Check if start date is greater than or equal to end date
                        if (!disableStartDate && !disableButtons) {
                          setStartDateTime(inputValue);
                          setShowInvalidDate(true);
                        }
                      } else {
                        setStartDateTime(inputValue);
                        setShowInvalidDate(false);
                      }
                    }}
                    onFocus={(e: any) => {
                      console.log("Input focused:", e.target.value);
                    }}
                  />
                </div>
                <div>
                  <label htmlFor="endDateTime">
                    <b> EndDate & Time</b> <b style={{ color: "red" }}>*</b>
                  </label>
                  <Input
                    type="datetime-local"
                    name="endDateTime"
                    id="endDateTime"
                    style={{ padding: "5% 8%", width: "90%" }}
                    value={
                      endDateTime.length == 19
                        ? endDateTime.slice(0, -3)
                        : endDateTime
                    }
                    min={
                      new Date(currentDate).getTime() >
                      new Date(startDateTime).getTime()
                        ? currentDate
                        : startDateTime
                    }
                    // max={'2099-12-30T23:59'}
                    disabled={disableButtons}
                    // onKeyDown={(e: any) => e.preventDefault()}
                    onChange={(e: any) => {
                      const inputValue = e.target.value;
                      const selectedEndDateTime = new Date(inputValue);
                      const startDateTimeValue = new Date(startDateTime).getTime();
                      const minDateTime = new Date(currentDate).getTime();

                      console.log(
                        selectedEndDateTime.getTime() < startDateTimeValue,
                        selectedEndDateTime.getTime(),
                        startDateTimeValue
                      );

                      // Validate date format and check for invalid dates (including hours > 23)
                      const dateTimePattern = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}$/;
                      if (!dateTimePattern.test(inputValue)) {
                        if (!disableButtons) {
                          setEndDateTime(inputValue);
                          setShowInvalidDate(true);
                        }
                        return;
                      }

                      const [datePart, timePart] = inputValue.split('T');
                      const [year, month, day] = datePart.split('-').map(Number);
                      const [hours, minutes] = timePart.split(':').map(Number);

                      // Check for invalid hour (must be 0-23 in 24-hour format)
                      if (hours > 23 || minutes > 59) {
                        if (!disableButtons) {
                          setEndDateTime(inputValue);
                          setShowInvalidDate(true);
                        }
                        return;
                      }

                      // Check if the date itself is valid (e.g., no Nov 31, Feb 30)
                      if (isNaN(selectedEndDateTime.getTime()) || 
                          selectedEndDateTime.getFullYear() !== year ||
                          selectedEndDateTime.getMonth() !== month - 1 ||
                          selectedEndDateTime.getDate() !== day ||
                          selectedEndDateTime.getHours() !== hours ||
                          selectedEndDateTime.getMinutes() !== minutes) {
                        if (!disableButtons) {
                          setEndDateTime(inputValue);
                          setShowInvalidDate(true);
                        }
                        return;
                      }

                      const selectedEndDateTimeMs = selectedEndDateTime.getTime();

                      // Check if manually entered end date is less than or equal to start date, or less than today
                      if (selectedEndDateTimeMs <= startDateTimeValue || selectedEndDateTimeMs < minDateTime) {
                        if (!disableButtons) {
                          setEndDateTime(inputValue);
                          setShowInvalidDate(true);
                        }
                      } else {
                        setEndDateTime(inputValue);
                        setShowInvalidDate(false);
                      }
                    }}
                  />
                </div>
              </div>
              {showInvalidDate && (
                <p
                  className="ln-c-field-info ln-c-field-info--error"
                  style={errorStyle}
                >
                  The given Dates are invalid please check once!
                </p>
              )}
            </ContractorFormField>
          </div>
          {/* )} */}
          {/* <hr /> */}
          <Card>
            <GridWrapper verticalAlign="center">
              {/* <div data-testid="accordion-multiple"> */}
              <div className="weekendHeadings">
                <GridItem
                  className="formGridAlign textAlignLast_Center"
                  size={{ lg: "1/5", md: "3/12", sm: "3/12", default: "3/12" }}
                >
                  <b>Name</b> <b style={{ color: "red" }}>*</b>
                </GridItem>
                <GridItem
                  className="formGridAlign textAlignLast_Center"
                  size={{ lg: "1/8", md: "2/12", sm: "2/12", default: "2/12" }}
                >
                  <b>Level</b>
                </GridItem>
                <GridItem
                  className="formGridAlign textAlignLast_Center"
                  size={{ lg: "1/12", md: "1/12", sm: "2/12", default: "2/12" }}
                >
                  <b>Phone</b>
                </GridItem>
                <GridItem
                  className="formGridAlign textAlignLast_Center"
                  size={{ lg: "3/12", md: "4/12", sm: "2/12", default: "2/12" }}
                >
                  <b>Email</b>
                </GridItem>
                <GridItem
                  className="formGridAlign textAlignLast_Center"
                  size={{ lg: "2/12", md: "2/12", sm: "2/12", default: "2/12" }}
                >
                  <b>Note</b>
                </GridItem>
                <GridItem
                  className="formGridAlign textAlignLast_Center"
                  size={{ lg: "2/12", md: "1", sm: "1/12", default: "1/12" }}
                ></GridItem>
              </div>
              {weekendsRow
                .filter((row: any) => row.isNew !== 0)
                .map((row: any, index: any) => (
                  <div className="weekendContents">
                    <GridItem
                      className="formGridAlign justifyItems"
                      size={{
                        lg: "1/5",
                        md: "3/12",
                        sm: "5/12",
                        ss: "6/12",
                        xs: "7/12",
                        default: "1/1",
                      }}
                    >
                      <div className="dropDownAlign wknd_name" key={row.rowId}>
                        <label>
                          Name <b style={{ color: "red" }}>*</b>
                        </label>
                        <AutocompleteField
                          placeholder={row.name ? row.name : "Please Select"}
                          name={row.name}
                          // value={row.name}
                          options={users}
                          noResultsMessage="No stores found"
                          // onChange={(users: any) =>
                          //   handleChange(users, row.id, row.rowId)
                          // }
                          onSelect={(users: any) =>
                            handleSelect(users, row.id, row.rowId)
                          }
                          disabled={disableButtons}
                        />
                      </div>
                    </GridItem>
                    <GridItem
                      className="formGridAlign textAlignLast_Center"
                      size={{
                        lg: "1/8",
                        md: "2/12",
                        sm: "3/12",
                        ss: "6/12",
                        xs: "5/12",
                        default: "1/1",
                      }}
                    >
                      <div className="dropDownAlign wknd_level">
                        <label>Level </label>
                        <SelectField
                          name="contractorSelector"
                          value={row.level}
                          placeholder="Please Select"
                          noResultsMessage="No data found"
                          options={levels}
                          onChange={(e: any) =>
                            onChanageLevels(e.target.value, row.rowId)
                          }
                          disabled={disableButtons}
                        />
                      </div>
                    </GridItem>
                    <GridItem
                      className="formGridAlign textAlignLast_Center"
                      size={{
                        lg: "1/12",
                        md: "1/12",
                        sm: "4/12",
                        ss: "3/12",
                        xs: "4/12",
                        default: "1/1",
                      }}
                    >
                      <div
                        style={{ width: "max-content" }}
                        className="rowTextAlign wknd_phone"
                      >
                        <label>Phone </label>
                        <p>{row.phone}</p>
                      </div>
                    </GridItem>
                    <GridItem
  className="formGridAlign textAlignLast_Center"
  size={{
    lg: "3/12",
    md: "4/12",
    sm: "4/12",
    ss: "4/12",
    xs: "8/12",
    default: "1/1",
  }}
>
  <div className="rowTextAlign wknd_email">
    <label>Email</label>
    <p
      onMouseOver={() => !isTouchDevice && handleMouseOverEmail(row.rowId, row.email)}
      onMouseOut={() => !isTouchDevice && handleMouseOutEmail()}
      onClick={() => handleEmailToggle(row.rowId, row.email)} // Works for mobile
    >
      {truncateText(row.email ? row.email : "", 25)}
    </p>
    {popUpBox && hoveredEmailId === row.rowId && (
  <div ref={popoverRef} className="popover-dialog email">
    <p>{row.email}</p>
  </div>
)}
  </div>
</GridItem>
<GridItem
  className="formGridAlign"
  size={{
    lg: "2/12",
    md: "2/12",
    sm: "4/12",
    ss: "5/12",
    xs: "6/12",
    default: "1/1",
  }}
>
  <div className="wknd_notes">
    <label>Notes</label>
    <TextInputField
      onFocus={() => clearNotesPopUp()}
      id={row.id}
      value={row.notes}
      name="notes"
      placeholder="Notes"
      onChange={(e: any) => textInputOnChange(e, row.rowId)}
      onMouseOver={() => handleMouseOverNotes(row.rowId, row.notes)}
      onMouseOut={handleMouseOutNotes}
      onClick={() => handleClickNotes(row.rowId, row.notes)} // Works for mobile
      className="formInput"
    />
    {showNotesDialog &&
      hoveredRowId === row.rowId &&
      hoveredText && (
        <div className="popover-dialog">
          <p>{row.notes}</p>
        </div>
      )}
  </div>
</GridItem>

                    <GridItem
                      className="formGridAlign xxx"
                      size={{
                        lg: "2/12",
                        md: "1/1",
                        sm: "4/12",
                        ss: "1/1",
                        xs: "6/12",
                        default: "1/1",
                      }}
                    >
                      <div className="formButtonGroup buttonTopAlign">
                        {weekendsRow.filter((x: any) => x.isNew != 0).length >
                          1 && (
                          <OutlinedButton
                            id="removeButton"
                            disabled={disableButtons}
                            fullWidth
                            onClick={(e: React.MouseEvent<HTMLButtonElement>) =>
                              removeRowFromGrid(e, row.rowId)
                            }
                          >
                            Remove{" "}
                          </OutlinedButton>
                        )}
                        {weekendsRow.filter((x: any) => x.isNew != 0).length ==
                          index + 1 && (
                          <FilledButton
                            id="addButton"
                            disabled={disableButtons}
                            fullWidth
                            onClick={addRowToGrid}
                            style={{ paddingLeft: "5px" }}
                          >
                            Add
                          </FilledButton>
                        )}
                      </div>
                    </GridItem>
                    {/* <GridItem size={{ lg: '1/12', ss: '6/12'  xs: '6/12',,default: '1/1' }}>1/12</GridItem> */}
                  </div>
                ))}
              <>
                <div className="formButtonGroup">
                  {/* <GridItem > */}
                  <OutlinedButton
                    className="formDiscardButton"
                    disabled={disableButtons}
                    onClick={() => {
                      setModalState("discard");
                    }}
                  >
                    Discard
                  </OutlinedButton>
                  {/* </GridItem> */}
                  {/* <GridItem > */}
                  <FilledButton
                    className="formSaveButton"
                    disabled={disableButtons}
                    onClick={() => {
                      handleDateOnSave();
                    }}
                  >
                    Save
                  </FilledButton>
                  {/* </GridItem> */}
                </div>
              </>
            </GridWrapper>
          </Card>
        </div>
      </div>
    </>
  );
};

export default AddWeekend;



